var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('iframe',{staticClass:"link-iframe",attrs:{"src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }